import { ref } from "vue";
import { signOut } from "firebase/auth";
import { projectAuth } from "../firebase/config";
import store from "../store/index";
import getUserDocument from "./getUserDocument";
import { resolveAccountContext, applyAccountContextToStore } from "./accountContext";
// refs
const user = ref(projectAuth.currentUser);

// auth changes
projectAuth.onAuthStateChanged(async (_user) => {
  user.value = _user;
  if (_user) {
    const accountContext = await resolveAccountContext(_user);
    if (accountContext?.status === "suspended") {
      await signOut(projectAuth);
      return;
    }
    applyAccountContextToStore({
      authUser: _user,
      context: accountContext,
      store,
    });

    await getUserDocument(accountContext?.ownerUid || _user.uid);
    const subscription = store.state.userConfig?.subscription;
    if (subscription === true || subscription === "true") {
      store.state.hasSubscribed = true;
    }
    store.state.loggedIn = true;
    store.state.infoLoaded = true;
  } else {
    store.state.currentUser = "";
    store.state.authUser = null;
    store.state.accountOwnerId = null;
    store.state.accountContext = null;
    store.state.accountMemberMenuTabsBlocked = [];
    store.state.accountMemberPartnerPricing = null;
    store.state.loggedIn = false;
  }
});
const getUser = () => {
  return { user };
};

export default getUser;
